export default __webpack_public_path__ + "static/stanleyknife-acefefed83bd28072b7d98f90db4fb93.png";